import { memo } from 'react';
import { Alert, Button } from 'react-bootstrap';

interface ErrorAlertProps {
  readonly message: string;
  readonly onRetry?: () => void;
}

export const ErrorAlert = memo<ErrorAlertProps>(function ErrorAlert({
  message,
  onRetry,
}) {
  return (
    <Alert variant="danger">
      <Alert.Heading>Error</Alert.Heading>
      <p>{message}</p>
      {onRetry && (
        <Button variant="outline-danger" onClick={onRetry}>
          Try Again
        </Button>
      )}
    </Alert>
  );
});
